export const projects = [
  {
    id: 'studio-fescina',
    titulo: 'Site Institucional para Academia',
    segmento: 'Academia & Fitness',
    categoria: 'sites',
    descricaoCurta: 'Presença digital profissional com modalidades, horários, diferenciais e contato facilitado.',
    thumb: '/projects/studio-fescina/01-home.png',
    thumbFallbacks: [],
    video: '/projects/studio-fescina/demo.mp4',
    galeria: [
      { src: '/projects/studio-fescina/01-home.png', alt: 'Página inicial' },
      { src: '/projects/studio-fescina/02-modalidade.png', alt: 'Seção de modalidades' },
      { src: '/projects/studio-fescina/03-horarios.png', alt: 'Seção de horários' },
      { src: '/projects/studio-fescina/04-contato.png', alt: 'Seção de contato' },
    ],
    objetivo:
      'Fortalecer a presença digital da academia, apresentando modalidades, horários e diferenciais com credibilidade.',
    solucao:
      'Site institucional responsivo com serviços, diferenciais, WhatsApp integrado e navegação mobile.',
    desafios:
      'Transmitir energia e profissionalismo organizando informações para diferentes perfis de visitantes.',
    solucaoDesafio:
      'Design com hierarquia visual clara, navegação intuitiva e chamadas estratégicas até o contato.',
    link: 'https://studiofescina.msdigitais.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'advocacia-luciana',
    titulo: 'Site Institucional para Advocacia',
    segmento: 'Advocacia',
    categoria: 'sites',
    descricaoCurta: 'Site profissional com áreas de atuação, FAQ, depoimentos, formulário de contato e WhatsApp integrado.',
    thumb: '/projects/advocacia-luciana/01-home.png',
    thumbFallbacks: ['/projects/advocacia-luciana/01-home.jpg'],
    video: '/projects/advocacia-luciana/demo.mp4',
    galeria: [
      { src: '/projects/advocacia-luciana/01-home.png', alt: 'Página inicial' },
      { src: '/projects/advocacia-luciana/02-sobre.png', alt: 'Sobre o escritório' },
      { src: '/projects/advocacia-luciana/03-area-atuacao.png', alt: 'Áreas de atuação' },
    ],
    objetivo:
      'Fortalecer a presença digital do escritório, transmitir credibilidade e facilitar o contato com clientes.',
    solucao:
      'Site responsivo com áreas de atuação, FAQ, depoimentos, formulário e integração com WhatsApp.',
    desafios:
      'Organizar um grande volume de informações jurídicas de forma clara e acessível.',
    solucaoDesafio:
      'Estruturação por seções e FAQ categorizado para navegação simples e profissional.',
    link: 'https://lucianachinedez.adv.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'clinica-odontologica',
    titulo: 'Site Institucional para Clínica Odontológica',
    segmento: 'Saúde & Odontologia',
    categoria: 'sites',
    descricaoCurta: 'Site moderno com tratamentos, localização, galeria de imagens e contato via WhatsApp.',
    thumb: '/projects/clinica-odontologica/01-home.png',
    thumbFallbacks: [],
    video: '/projects/clinica-odontologica/demo.mp4',
    galeria: [
      { src: '/projects/clinica-odontologica/01-home.png', alt: 'Página inicial' },
      { src: '/projects/clinica-odontologica/02-servicos.png', alt: 'Serviços e tratamentos' },
      { src: '/projects/clinica-odontologica/03-sobre.png', alt: 'Sobre a clínica' },
    ],
    objetivo:
      'Fortalecer a presença digital da clínica, transmitir credibilidade e ser encontrada no Google.',
    solucao:
      'Site responsivo com tratamentos, localização, galeria de imagens e contato via WhatsApp.',
    desafios:
      'Criar identidade visual acolhedora e melhorar a visibilidade nos mecanismos de busca.',
    solucaoDesafio:
      'Layout personalizado com SEO básico e conteúdo organizado por seções estratégicas.',
    link: 'https://clinicarenatafranca.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'mce',
    titulo: 'Portal Empresarial Multi-Páginas',
    segmento: 'Comunidade Empresarial',
    categoria: 'sites',
    descricaoCurta:
      'Portal com múltiplas páginas para divulgar empresas, eventos e conteúdos da comunidade.',
    thumb: '/projects/mce/01-home.png',
    thumbFallbacks: [],
    video: '/projects/mce/demo.mp4',
    galeria: [
      { src: '/projects/mce/01-home.png', alt: 'Página inicial' },
      { src: '/projects/mce/02-oque-fazemos.png', alt: 'O que fazemos' },
      { src: '/projects/mce/03-historias.png', alt: 'Histórias' },
      { src: '/projects/mce/04-formulario.png', alt: 'Formulário de contato' },
    ],
    objetivo:
      'Criar uma presença digital profissional para divulgar empresas, eventos e conteúdos da comunidade.',
    solucao:
      'Desenvolvimento de um site completo com múltiplas páginas, áreas de divulgação, páginas individuais, eventos e canais de contato.',
    desafios:
      'Organizar diferentes conteúdos e segmentos em uma navegação simples e intuitiva.',
    solucaoDesafio:
      'Estruturação estratégica das páginas e categorias para facilitar a experiência do usuário.',
    link: 'https://redemce.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'tet-psicologia-clinica',
    titulo: 'Site Institucional – Psicologia Clínica',
    segmento: 'Psicologia & Saúde Mental',
    categoria: 'sites',
    descricaoCurta:
      'Site para psicólogas apresentarem a abordagem clínica, facilitar a busca por atendimento e o contato inicial.',
    thumb: '/projects/tet-psicologia-clinica/01-home.png',
    thumbFallbacks: [],
    video: '/projects/tet-psicologia-clinica/demo.mp4',
    galeria: [
      { src: '/projects/tet-psicologia-clinica/01-home.png', alt: 'Página inicial' },
      { src: '/projects/tet-psicologia-clinica/02-procurar.png', alt: 'Seção procurar atendimento' },
      { src: '/projects/tet-psicologia-clinica/03-abordagem.png', alt: 'Abordagem clínica' },
      { src: '/projects/tet-psicologia-clinica/04-sobre.png', alt: 'Sobre as profissionais' },
      { src: '/projects/tet-psicologia-clinica/05-formulario.png', alt: 'Formulário de contato' },
    ],
    objetivo:
      'Apresentar a abordagem das psicólogas com clareza e acolhimento, gerando confiança e facilitando o primeiro contato.',
    solucao:
      'Site institucional responsivo com apresentação da abordagem, busca por atendimento, sobre as profissionais e formulário de contato.',
    desafios:
      'Transmitir acolhimento e seriedade clínica em linguagem acessível, sem perder o caráter profissional.',
    solucaoDesafio:
      'Estrutura clara, textos orientados ao visitante e hierarquia visual suave, com caminho objetivo até o contato.',
    link: 'https://psicologiaclinicatt.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'cristiane-rosa',
    titulo: 'Site Institucional – Consultoria de Imagem',
    segmento: 'Consultoria de Imagem',
    categoria: 'sites',
    descricaoCurta: 'Site elegante para consultoria de imagem e coloração pessoal, com serviços, contato e WhatsApp.',
    thumb: '/projects/cristiane-rosa/01-home.png',
    thumbFallbacks: [],
    video: '/projects/cristiane-rosa/demo.mp4',
    galeria: [
      { src: '/projects/cristiane-rosa/01-home.png', alt: 'Página inicial' },
      { src: '/projects/cristiane-rosa/02-servicos.png', alt: 'Serviços oferecidos' },
      { src: '/projects/cristiane-rosa/03-contato.png', alt: 'Contato' },
    ],
    objetivo:
      'Fortalecer a presença digital e apresentar serviços de consultoria de imagem com credibilidade.',
    solucao:
      'Site responsivo com serviços, apresentação profissional, formulário e WhatsApp integrado.',
    desafios:
      'Transmitir elegância e profissionalismo alinhados à marca pessoal da cliente.',
    solucaoDesafio:
      'Identidade visual limpa, navegação simples e textos estratégicos focados nos serviços.',
    link: 'https://crisrosaconsultoria.msdigitais.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'will-maker',
    titulo: 'Site Institucional Empresarial',
    segmento: 'Serviços Empresariais',
    categoria: 'sites',
    descricaoCurta: 'Site responsivo que reúne serviços, informações e contato em um único link para divulgação.',
    thumb: '/projects/will-maker/01-home.png',
    thumbFallbacks: [],
    video: '/projects/will-maker/demo.mp4',
    galeria: [
      { src: '/projects/will-maker/01-home.png', alt: 'Página inicial' },
      { src: '/projects/will-maker/02-trabalhos.png', alt: 'Trabalhos realizados' },
      { src: '/projects/will-maker/03-servicos.png', alt: 'Serviços oferecidos' },
      { src: '/projects/will-maker/04-contato.png', alt: 'Contato' },
    ],
    objetivo:
      'Organizar serviços profissionalmente, substituir PDFs e ter um link único para divulgação online.',
    solucao:
      'Site responsivo reunindo informações, serviços e contato em um único ambiente digital.',
    desafios:
      'Organizar os serviços de forma clara e intuitiva, garantindo uma navegação simples e profissional.',
    solucaoDesafio:
      'Foi criada uma estrutura estratégica de páginas e seções, permitindo que os visitantes encontrassem rapidamente as informações desejadas.',
    link: 'https://willmaker.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'chaveiro',
    titulo: 'Site Institucional – Chaveiro',
    segmento: 'Chaveiro & Serviços',
    categoria: 'sites',
    descricaoCurta:
      'Site responsivo com catálogo de serviços, galeria de trabalhos, FAQ, WhatsApp e otimização para buscas locais.',
    thumb: '/projects/chaveiro/01-home.png',
    thumbFallbacks: [],
    video: '/projects/chaveiro/demo.mp4',
    galeria: [
      { src: '/projects/chaveiro/01-home.png', alt: 'Página inicial' },
      { src: '/projects/chaveiro/02-servicos.png', alt: 'Serviços oferecidos' },
      { src: '/projects/chaveiro/03-contato.png', alt: 'Contato' },
    ],
    objetivo:
      'Divulgar serviços profissionalmente, facilitar contato e aumentar visibilidade no Google regional.',
    solucao:
      'Site responsivo com catálogo de serviços, galeria, FAQ, WhatsApp e otimização para buscas.',
    desafios:
      'Apresentar diversos serviços especializados de forma simples e objetiva.',
    solucaoDesafio:
      'Estrutura com destaque nos principais serviços, CTAs estratégicos e seções de fácil navegação.',
    link: 'https://sosautoprog.com.br/',
    linkLabel: 'Visitar Site',
  },
  {
    id: 'sistema-academias',
    titulo: 'Sistema de Gestão para Academias',
    segmento: 'Gestão & Academias',
    categoria: 'sistemas',
    descricaoCurta: 'Sistema completo para gestão de alunos, pagamentos, agendamentos e relatórios.',
    thumb: '/projects/sistema-academias/01-home.png',
    thumbFallbacks: ['/projects/sistema-academias/01-home.jpg', '/assets/academia1.jpg'],
    video: '/projects/sistema-academias/demo.mp4',
    galeria: [
      { src: '/projects/sistema-academias/01-home.png', alt: 'Dashboard principal' },
      { src: '/assets/academia1.jpg', alt: 'Painel do sistema' },
      { src: '/assets/academia2.jpg', alt: 'Gestão de alunos' },
      { src: '/assets/academia3.jpg', alt: 'Relatórios' },
    ],
    objetivo: 'Automatizar a gestão de academias com controle de alunos, pagamentos e agendamentos.',
    solucao: 'Sistema web completo com cadastro de alunos, controle financeiro, agendamento e relatórios.',
    desafios: 'Integrar múltiplas funcionalidades em uma interface intuitiva para usuários não técnicos.',
    solucaoDesafio: 'Desenvolvi dashboards claros, fluxos simplificados e notificações automáticas.',
    link: null,
  },
  {
    id: 'app-agendamento',
    titulo: 'App de Gestão e Agendamento',
    segmento: 'Agendamento & Serviços',
    categoria: 'sistemas',
    descricaoCurta: 'Aplicativo para organizar clientes, agendamentos via WhatsApp e relatórios.',
    thumb: '/projects/app-agendamento/01-home.png',
    thumbFallbacks: ['/projects/app-agendamento/01-home.jpg', '/assets/agendamento1.jpg'],
    video: '/projects/app-agendamento/demo.mp4',
    galeria: [
      { src: '/projects/app-agendamento/01-home.png', alt: 'Dashboard principal' },
      { src: '/assets/agendamento1.jpg', alt: 'Painel do app' },
      { src: '/assets/agendamento2.jpg', alt: 'Agendamentos' },
      { src: '/assets/agendamento3.jpg', alt: 'Relatórios' },
    ],
    objetivo: 'Organizar agendamentos, clientes e serviços de forma prática e automatizada.',
    solucao: 'Aplicativo com cadastro de clientes, agendamento via WhatsApp e notificações automáticas.',
    desafios: 'Criar fluxo de agendamento simples integrado ao WhatsApp do cliente.',
    solucaoDesafio: 'Implementei integração direta com WhatsApp e interface mobile-first intuitiva.',
    link: 'https://msdigitais.com.br/agenda-eletronica/index.html',
    linkLabel: 'Visitar Site',
  },
];

export const filterOptions = [
  { id: 'todos', label: 'Todos' },
  { id: 'sites', label: 'Sites' },
  { id: 'sistemas', label: 'Sistemas' },
];

export const hasVideo = (project) => {
  if (!project?.video) return false;
  return true;
};

export const getThumbFallbacks = (project) => [
  ...(project.thumbFallbacks || []),
  project.thumb?.replace('.png', '.jpg'),
  project.thumb?.replace('.png', '.jpeg'),
  project.thumb?.replace('.png', '.webp'),
].filter((src, index, arr) => src && arr.indexOf(src) === index);
